import React from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */
var FUNCTION_REGEX = /react(\d+)?./i;
function classComponent(component) {
  return typeof component === 'function' && component.prototype && !!component.prototype.isReactComponent;
}

// Ensure compatibility with transformed code
function functionComponent(component) {
  return typeof component === 'function' && String(component).includes('return') && !!String(component).match(FUNCTION_REGEX) && String(component).includes('.createElement');
}
function component(component) {
  return classComponent(component) || functionComponent(component);
}
function element(typeElement) {
  return /*#__PURE__*/React.isValidElement(typeElement);
}
function DOMTypeElement(typeElement) {
  return element(typeElement) && typeof typeElement.type === 'string';
}
function compositeTypeElement(typeElement) {
  return element(typeElement) && typeof typeElement.type === 'function';
}
function compatible(item) {
  return element(item) || component(item);
}
var isReact = {
  classComponent: classComponent,
  functionComponent: functionComponent,
  component: component,
  element: element,
  DOMTypeElement: DOMTypeElement,
  compositeTypeElement: compositeTypeElement,
  compatible: compatible,
  toString: toString
};

export default isReact;
//# sourceMappingURL=is-react.esm.js.map
